import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "adults", label: "Adults" },
  { id: "kids", label: "Kids" },
];

const isKids = (p) => /^kids\b/i.test(p?.name || "");

export default function ProductList({ category, title, label }) {
  const [products, setProducts] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialFilter = searchParams.get("filter") || "all";
  const [filter, setFilter] = useState(FILTERS.some((f) => f.id === initialFilter) ? initialFilter : "all");

  useEffect(() => {
    api.get(`/products?category=${category}`).then((r) => setProducts(r.data));
  }, [category]);

  useEffect(() => {
    if (filter === "all") {
      if (searchParams.get("filter")) {
        searchParams.delete("filter");
        setSearchParams(searchParams, { replace: true });
      }
    } else if (searchParams.get("filter") !== filter) {
      searchParams.set("filter", filter);
      setSearchParams(searchParams, { replace: true });
    }
  }, [filter, searchParams, setSearchParams]);

  const hasKids = useMemo(() => products.some(isKids), [products]);

  const visible = useMemo(() => {
    if (filter === "kids") return products.filter(isKids);
    if (filter === "adults") return products.filter((p) => !isKids(p));
    return products;
  }, [products, filter]);

  return (
    <div data-testid={`${category}-page`} className="bg-ink text-white min-h-screen pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-mono text-xs uppercase tracking-[0.4em] text-adrenaline">{label}</div>
        <h1 className="text-display text-6xl md:text-8xl uppercase leading-none mt-3">{title}</h1>
        <div className="section-divider mt-12 mb-6" />

        {hasKids && (
          <div className="flex flex-wrap items-center gap-2 mb-8" data-testid="apparel-filter-bar">
            {FILTERS.map((f) => {
              const active = filter === f.id;
              return (
                <button
                  key={f.id}
                  onClick={() => setFilter(f.id)}
                  data-testid={`apparel-filter-${f.id}`}
                  className={`text-mono text-[11px] uppercase tracking-[0.3em] px-4 py-2 border transition-colors ${
                    active
                      ? "bg-adrenaline border-adrenaline text-black"
                      : "border-zinc-700 text-zinc-300 hover:border-zinc-400 hover:text-white"
                  }`}
                >
                  {f.label}
                </button>
              );
            })}
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1">
          {visible.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
        {visible.length === 0 && (
          <div className="text-mono text-zinc-500 text-sm uppercase tracking-widest py-20 text-center">
            No drops yet. Check back soon.
          </div>
        )}
      </div>
    </div>
  );
}
